module.exports = __webpack_public_path__ + "static/angela-f6d01a316b8507e73cdd760f87aefb84.webp";